import styled from "styled-components";
import { COLORS } from "../../constants/colors";

interface Ilabel{
    message: string;
}

const Label = styled.div<any>`
    color:  var(--black_text_color1);
    font-weight: bold;
    font-size: x-large;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    padding-top: 8em;
    
    h2{
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: center;
        color:var(--black_text_color1);
        font-size: xx-large;
    }
    .fa-box-archive{
        font-size: 200px;
        color:var(--black_text_color3);
        margin-bottom: 10px;
    }

`;

const LabelNotFound: React.FC<Ilabel> = ({message})=>{
    return(
        <Label>
           
           
            <i className="fa-solid fa-box-archive"></i>
            <h2>{message}</h2>
        </Label>
    )
}

export default LabelNotFound;